import { render, staticRenderFns } from "./LatestTrades.vue?vue&type=template&id=ce20f478"
import script from "./LatestTrades.vue?vue&type=script&lang=js"
export * from "./LatestTrades.vue?vue&type=script&lang=js"
import style0 from "./LatestTrades.vue?vue&type=style&index=0&id=ce20f478&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports